export default "__VITE_ASSET__SZ7aAJZC__"